import { useCallback } from 'react';

import { Visit } from '@dreryk/egabinet-visit-frontend-api';

import { ContextDialog, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

import { appointmentsTranslationKeys, calendarTranslationKeys } from '../../../../../translations';

type AppointmentDetailsShowVisitButtonProps = {
   readonly visitId: Visit['id'];
   readonly patientId: Visit['patient']['id'];
};

export const AppointmentDetailsShowVisitButton = (props: AppointmentDetailsShowVisitButtonProps): JSX.Element => {
   const push = useHistoryPushWithBackAction(true);

   const handleClick = useCallback(() => {
      push(
         visitPaths.getVisitHistoryPath({
            params: {
               patientId: props.patientId,
            },
            searchParams: {
               visitId: props.visitId,
            },
         }),
         {
            label: calendarTranslationKeys.goBackToCalendar,
         }
      );
   }, [push, props.patientId, props.visitId]);

   return <ContextDialog.ConfirmButton label={appointmentsTranslationKeys.show} onClick={handleClick} />;
};
